import { store } from '@redux/store'

export const getDialogWindowsFromReduxStore = () => {
  return store.getState().dialogWindowManager.dialogWindows
}
